import React, { Component } from 'react'
import GeneratedLicenseReview from '../../containers/GeneratedLicenses/GeneratedLicenseReview'
import GeneratedLicenseConfirm from '../../containers/GeneratedLicenses/GeneratedLicenseConfirm'
import { Icon, Step, Grid, Header, Divider } from 'semantic-ui-react'
import GeneratedLicenseInfo from "../../containers/GeneratedLicenses/GeneratedLicenseInfo";

class GeneratedLicenseWizard extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { page, initialValues, previousPage, nextPage, onClose} = this.props;

        return (
            <div>
                <Grid centered={true}>
                    <Grid.Row stretched>
                        <Grid.Column width={16}>
                            <Step.Group >
                                <Step active={page === 1}>
                                    <Icon name='user'/>
                                    <Step.Content>
                                        <Step.Title>Collect</Step.Title>
                                        <Step.Description>Collect User Information</Step.Description>
                                    </Step.Content>
                                </Step>

                                <Step active={page === 2}>
                                    <Icon name='content'/>
                                    <Step.Content>
                                        <Step.Title>Review</Step.Title>
                                        <Step.Description>Review License Certificate</Step.Description>
                                    </Step.Content>
                                </Step>

                                <Step active={page === 3}>
                                    <Icon name='info'/>
                                    <Step.Content>
                                        <Step.Title>Confirm</Step.Title>
                                        <Step.Description>Confirm Certificate</Step.Description>
                                    </Step.Content>
                                </Step>
                            </Step.Group>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row >
                        <Grid.Column width={10} stretched={true}>
                            { page === 1 && <GeneratedLicenseInfo initialValues={initialValues}/> }
                            { page === 2 && <GeneratedLicenseReview previousPage={previousPage} nextPage={nextPage}/> }
                            { page === 3 && <GeneratedLicenseConfirm previousPage={previousPage} onClose={onClose} /> }

                        </Grid.Column>
                    </Grid.Row>
                </Grid>

            </div>
        )
    }
}


export default GeneratedLicenseWizard;



